import { brand } from '@/commonTypes';
import { Breadcrumb } from '@/components/general/BreadCrumb';
import React from 'react';
import styles from './styles.module.css';
import BrandLogo from '../../BrandsContent/BrandCard/Brandlogo';
import BrandInfo from '../BrandInfo';
import { useTranslations } from 'next-intl';

export default function SingleBrandHero({ data }: { data?: brand }) {
  const tCommon = useTranslations('common');

  return (
    <>
      <Breadcrumb
        items={[
          { label: tCommon('homeTitle'), to: '/' },
          { label: tCommon('seo.brands.title'), to: '/brands' },
          { label: data?.brand || '' },
        ]}
      />
      <div className={`${styles.infoContainer}`}>
        <BrandLogo
          index={0}
          name={data?.brand}
          className={`${styles.logo}`}
          random={true}
          image={data?.image}
        />
        <BrandInfo item={data} />
      </div>
      <p className={styles.description}>{data?.description}</p>
    </>
  );
}
